import L from "leaflet";

const API_KEY = 'ZIKgHZvpa7XxDTYKt8UtnNXtkpvuyeZfkKwS_LK9ugQ';

document.addEventListener("snippetready", function(event) {
	const parent = event.detail.parent;
	const position = [50.0289744, 15.5273406];

	const mapElement = parent.querySelector("#map");
	if (!mapElement) {
		return;
	}

	const map = L.map(mapElement).setView(position, 10);
	map.attributionControl.setPrefix(false);

	L.tileLayer(`https://api.mapy.cz/v1/maptiles/basic/256@2x/{z}/{x}/{y}?apikey=${API_KEY}`, {
		minZoom: 0,
		maxZoom: 19,
		attribution: '<a href="https://api.mapy.cz/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>',
	}).addTo(map);

	L.marker(position, {
		icon: L.icon({
			iconUrl: RAILS_ASSET_URL("map_pin.svg"),
			iconSize: [48, 64],
			iconAnchor: [24, 64],
		})
	}).addTo(map);


});
